var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchGray500Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74902 1.66699C12.6656 1.66699 15.8328 4.83348 15.833 8.75C15.833 10.4166 15.2496 12.0003 14.333 13.167L18.083 16.917C18.4162 17.2503 18.4163 17.7507 18.083 18.084C17.9163 18.2507 17.6657 18.334 17.499 18.334C17.3324 18.3339 17.0826 18.2504 16.916 18.084L13.166 14.334C11.916 15.2506 10.4156 15.834 8.74902 15.834C4.83251 15.8338 1.66602 12.6666 1.66602 8.75C1.66619 4.83359 4.83262 1.66717 8.74902 1.66699ZM8.74902 3.33398C5.74928 3.33416 3.33318 5.75026 3.33301 8.75C3.33301 11.7499 5.74917 14.1668 8.74902 14.167C10.249 14.167 11.583 13.584 12.583 12.584C13.583 11.584 14.166 10.25 14.166 8.75C14.1658 5.75015 11.7489 3.33398 8.74902 3.33398Z",
    fill: "#555555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7985_57657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74902 1.66699C12.6656 1.66699 15.8328 4.83348 15.833 8.75C15.833 10.4166 15.2496 12.0003 14.333 13.167L18.083 16.917C18.4162 17.2503 18.4163 17.7507 18.083 18.084C17.9163 18.2507 17.6657 18.334 17.499 18.334C17.3324 18.3339 17.0826 18.2504 16.916 18.084L13.166 14.334C11.916 15.2506 10.4156 15.834 8.74902 15.834C4.83251 15.8338 1.66602 12.6666 1.66602 8.75C1.66619 4.83359 4.83262 1.66717 8.74902 1.66699ZM8.74902 3.33398C5.74928 3.33416 3.33318 5.75026 3.33301 8.75C3.33301 11.7499 5.74917 14.1668 8.74902 14.167C10.249 14.167 11.583 13.584 12.583 12.584C13.583 11.584 14.166 10.25 14.166 8.75C14.1658 5.75015 11.7489 3.33398 8.74902 3.33398Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7985_57657)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGray500Icon);
export default __webpack_public_path__ + "static/media/search_gray500_icon.9ef5282ebb87e9401c0366e394e7ccbd.svg";
export { ForwardRef as ReactComponent };